import { useI18n } from 'vue-i18n';
// const { t } = useI18n();
import ic_logo_kex from '@/assets/img/ic_logo_kex.png'
import ic_logo_kex_orange from '@/assets/img/ic_logo_kex_orange.png'
import ic_mobile_bg from '@/assets/img/kex/ic_mobile_bg.jpg'
import ic_pc_bg from '@/assets/img/kex/ic_pc_bg.jpg'



// 默认配置文件
export function getConfig(i18nInstance, channel) {
    if (channel === ('kex')) { // kex渠道配置
        return {
            'logo': ic_logo_kex, // logo
            'logo_login': ic_logo_kex_orange, // logo
            'login_mobile_bg': ic_mobile_bg, // 登录页移动端背景
            'login_pc_bg': ic_pc_bg, // 登录页pc端背景
            'language': true, // 语言开关
            'languageList': { // 语言列表
                'zh-CN': i18nInstance.t('zh-CN'),
                'en': i18nInstance.t('en'),
                'th-TH': i18nInstance.t('th-TH')
            },
            'defaultThemeColor': "#f37024",
            'agreementTitle': i18nInstance.t('unable_claims'), // 协议标题
            'agreementContent': i18nInstance.t('consent_decline_consequence'), // 协议内容
        };
    } else { // 其他配置文件
        return {
            'logo': ic_logo_kex, // logo
            'logo_login': ic_logo_kex_orange, // logo
            'login_mobile_bg': ic_mobile_bg, // 登录页移动端背景
            'login_pc_bg': ic_pc_bg, // 登录页pc端背景
            'language': true, // 语言开关
            'languageList': { // 语言列表
                'zh-CN': i18nInstance.t('zh-CN'),
                'en': i18nInstance.t('en'),
                'th-TH': i18nInstance.t('th-TH')
            },
            'defaultThemeColor': "#f37024",
            'agreementTitle': i18nInstance.t('unable_claims'), // 协议标题
            'agreementContent': i18nInstance.t('consent_decline_consequence'), // 协议内容
        };
    }

}
